import { render, staticRenderFns } from "./Cocreation.vue?vue&type=template&id=3509de04&scoped=true"
import script from "./Cocreation.vue?vue&type=script&lang=js"
export * from "./Cocreation.vue?vue&type=script&lang=js"
import style0 from "./Cocreation.vue?vue&type=style&index=0&id=3509de04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509de04",
  null
  
)

export default component.exports